import React, { useEffect, useState } from 'react';
import { makeStyles, } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import {
  Grid,
  FormControl,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
  Divider,
  Button
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { FormatInputNumero, SelectAsincronico, SelectFree, TextFieldAutoComplete } from 'components';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    '& .MuiFormLabel-asterisk.MuiInputLabel-asterisk': {
      color: 'red'
    }
  },
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    padding: theme.spacing(2),
  },

}));
export default function FormularioPropuesta(props) {
  const { register, errors, setValue, watch, control, defaultItem, getValues, isEdicionOrden, ctlg } = props;
  const classes = useStyles();
  // const [loading, setLoading] = useState(false);
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const fechaActual = year + '-' + month + '-' + day;
  // const [dataPropuesta, setDataPropuesta] = useState({ desde: fechaActual, hasta: fechaActual, comentario: null });

  useEffect(() =>{
    if(defaultItem.propuesta.length > 0 ){
      console.log('valores');
    }else{
      setValue('desde', fechaActual);
      setValue('hasta', fechaActual);
      setValue('personas', null);
      setValue('comentario', null);
    }
  },[]);
  return (
    <Grid container className={classes.root} spacing={2}>
      <Grid item md={4} xs={7}>
        <TextField
          variant="outlined" fullWidth size="small" label="Desde" type="date" value={watch('desde')} InputLabelProps={{ shrink: true }}
          name="desde" inputRef={register({ required: { value: true, message: 'Campo requerido' } })}
          error={Boolean(errors.desde)} helperText={errors.desde?.message} />
      </Grid>
      <Grid item md={4} xs={7}>
        <TextField
          variant="outlined" fullWidth size="small" label="Hasta" type="date" value={watch('hasta')} InputLabelProps={{ shrink: true }}
          name="hasta" inputRef={register({ required: { value: true, message: 'Campo requerido' } })}
          error={Boolean(errors.hasta)} helperText={errors.hasta?.message} />
      </Grid>
      <Grid item md={4} xs={7}>
        <Autocomplete
          multiple
          options={ctlg.personas}
          getOptionLabel={(option) => option.npersona}
          getOptionSelected={(option, value) => option.idpersona == value.idpersona}
          value={watch('personas')}
          // onChange={cambioProyecto}
          size="small"
          fullWidth
          renderInput={(params) => (
            <TextField label="Equipo" variant="outlined" {...params}
              error={errors.personas != undefined} helperText={errors.personas}
            />
          )}
        />
      </Grid>
      <Grid item md={12} xs={12}>
        <TextField size="small" multiline error={Boolean(errors.comentario)} helperText={errors.comentario}
          variant="outlined" fullWidth label="Comentario" name="comentario" value={watch('comentario')}
        />
      </Grid>
    </Grid>

  );
}
